const variantAttributes = Array.from(
  document.querySelectorAll("[data-attributes][data-variant]")
);

document.addEventListener("variant:change", function (evt) {
  const target = evt.detail.variant;

  variantAttributes.forEach((variant) => {
    if (!variant.hasAttribute("hidden")) {
      variant.setAttribute("hidden", "hidden");
    }

    if (variant.getAttribute("data-variant").toString() === target.id.toString()) {
      variant.removeAttribute("hidden");
    }
  });
});
